import { colors } from 'styles/theme';

// import { StylesConfig } from 'react-select/dist/types';
// import { OptionType } from 'deprecated-enkel/components/Select';

export const smallSelectStyle = {
    option: (provided: any, state: any) => ({
        ...provided,
        color: state.isSelected || state.isFocused ? colors.black : provided.color,
        backgroundColor: state.isFocused ? colors.culturedGrey : provided.backgroundColor,
    }),
    control: (provided: any, state: any) => ({
        ...provided,
        borderColor: state.isFocused ? colors.blueOutline : colors.borderGrey,
        boxShadow: state.isFocused ? `0 0 0 1px ${colors.blueOutline}` : provided.boxShadow,
        ':hover': {
            borderColor: colors.blueOutline,
        },
    }),
};
